export default __webpack_public_path__ + "static/media/imgprofile.feddbfc4.png";